import { render } from "./ReportTemplate.vue?vue&type=template&id=34c0c190"
import script from "./ReportTemplate.vue?vue&type=script&lang=js"
export * from "./ReportTemplate.vue?vue&type=script&lang=js"

import "./ReportTemplate.vue?vue&type=style&index=0&id=34c0c190&lang=scss"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__